import { useAppSelector } from "./store";

import config from "./appconf";

function ReadyButton() {
  const player = useAppSelector((state) => {
    const userId = state.profile.id;
    return state.players.find((player) => {
      return player.id === userId;
    });
  });

  let playerIsReady: boolean;
  let buttonText: string;

  if (player === undefined || !player.ready) {
    playerIsReady = false;
    buttonText = "ready";
  } else {
    playerIsReady = true;
    buttonText = "not ready";
  }

  const handleClick = () => {
    console.log("calling handleClick");
    console.log(`playerIsReady=${playerIsReady}`);
    if (playerIsReady) {
      fetch(`${config.baseUrl}/api/v1/unready`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
      });
    } else {
      console.log("posting ready");
      fetch(`${config.baseUrl}/api/v1/ready`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
      })
        .then((res) => {
          console.log(`received ${res.status} from api`);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <div className="center">
      <button className="primaryButton" type="button" onClick={handleClick}>
        {buttonText}
      </button>
    </div>
  );
}

export default ReadyButton;
